import { Injectable } from '@angular/core';
import { IntegrationTableQuery } from '@y42/integration';
import { SqlModelingTableQuery } from '@y42/sql-model';
import { UiModelingTableQuery } from '@y42/ui-model';
import { combineLatest, map, Observable, shareReplay } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class Y42AllDatasourceTablesQuery {
  constructor(
    private readonly integrationTablesQuery: IntegrationTableQuery,
    private readonly uiModelingTablesQuery: UiModelingTableQuery,
    private readonly sqlModelingTablesQuery: SqlModelingTableQuery,
  ) {}

  readonly loading$: Observable<boolean> = combineLatest([
    this.integrationTablesQuery.selectLoading(),
    this.uiModelingTablesQuery.selectLoading(),
    this.sqlModelingTablesQuery.selectLoading(),
  ]).pipe(
    map(
      ([integrationsLoading, uiModelingLoading, sqlModelingLoading]) =>
        integrationsLoading || uiModelingLoading || sqlModelingLoading,
    ),
  );

  readonly tables$ = combineLatest([
    this.integrationTablesQuery.tables$,
    this.uiModelingTablesQuery.tables$,
    this.sqlModelingTablesQuery.tables$,
  ]).pipe(
    map(([integrationTables, uiModelingTables, sqlModelingTables]) => [
      ...integrationTables,
      ...uiModelingTables,
      ...sqlModelingTables,
    ]),
    shareReplay({ bufferSize: 1, refCount: true }),
  );

  selectAll() {
    return combineLatest([
      this.integrationTablesQuery.selectAll(),
      this.uiModelingTablesQuery.selectAll(),
      this.sqlModelingTablesQuery.selectAll(),
    ]).pipe(map(([integrations, uiModels, sqlModels]) => [...integrations, ...uiModels, ...sqlModels]));
  }

  selectUIEntity(tableId: string) {
    return combineLatest([
      this.integrationTablesQuery.selectUIEntity(tableId),
      this.uiModelingTablesQuery.selectUIEntity(tableId),
      this.sqlModelingTablesQuery.selectUIEntity(tableId),
    ]).pipe(
      map(([integrationTable, uiModelTable, sqlModelTable]) => integrationTable || uiModelTable || sqlModelTable),
    );
  }

  getEntity(tableId: string) {
    return (
      this.integrationTablesQuery.getEntity(tableId) ||
      this.uiModelingTablesQuery.getEntity(tableId) ||
      this.sqlModelingTablesQuery.getEntity(tableId)
    );
  }

  getUIEntity(tableId: string) {
    return (
      this.integrationTablesQuery.getUIEntity(tableId) ||
      this.uiModelingTablesQuery.getUIEntity(tableId) ||
      this.sqlModelingTablesQuery.getUIEntity(tableId)
    );
  }
}
